import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { withRouter, RouteComponentProps } from 'react-router';
import { Grid, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const Header: FC<RouteComponentProps> = ({ history }) => (
  <Grid container alignItems="center" justify="space-between">
    <Grid item>
      <Typography color="inherit" variant="h4">
        <Trans i18nKey="components:newGroup" />
      </Typography>
    </Grid>
    <Grid item>
      <IconButton onClick={() => history.goBack()}>
        <CloseIcon />
      </IconButton>
    </Grid>
  </Grid>
);

export default withRouter(Header);
